// tslint:disable: variable-name
import { BaseResourceModel } from '../../models/base-resource.model';
import { Orgao } from '../comum/orgao.model';
import { Pessoa } from '../comum/pessoa.model';
import { Favorecido } from './favorecido.model';

export class FavorecidoSocio extends BaseResourceModel {
    constructor(
        public id?: number,
        public socio?: boolean,
        public administrador?: boolean,
        public responsavel?: boolean,
        public pessoa?: Pessoa,
        public favorecido?: Favorecido,
        public editavel?: boolean,
        public orgao?: Orgao
    ) {
        super();
    }
    static converteJson(json: any): FavorecidoSocio {
        return Object.assign(new FavorecidoSocio(), json);
    }
}
